// extracted by mini-css-extract-plugin
export default {"wrapper":"AssistantTextMessage_wrapper__HcSqm","messageContent":"AssistantTextMessage_messageContent__ndKuN"};